import { ButtonClean } from '@fourthwall/components';
import { AnalyticsApiClient } from '@fourthwall/services/dist/AnalyticsApiClient';
import { useMutation } from '@tanstack/react-query';
import { routing } from '@utils/routing';
import { reverse } from 'named-urls';
import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalyticsParams } from '../../modules/AnalyticsParams';
import * as S from './AnalyticsReports.styled';
import { AnalyticsReportsView } from './AnalyticsReportsView';
import { DownloadButton } from './components/DownloadButton/DownloadButton';
import { downloadCsv } from './utils/downloadCsv';
const reports = {
    AOV: {
        name: 'Average Order Value',
    },
    CUSTOMERS_OVER_TIME: {
        name: 'Customers Over Time',
    },
    SALES_OVER_TIME: {
        name: 'Sales Over Time',
    },
    SALES_OVER_TIME_DETAILED: {
        name: 'Sales Over Time (detailed)',
    },
    SALES_OVER_TIME_DONATION: {
        name: 'Sales Over Time (donations)',
    },
    SALES_OVER_TIME_MEMBERSHIP: {
        name: 'Sales Over Time (memberships)',
    },
    SALES_OVER_TIME_ORDER: {
        name: 'Sales Over Time (orders)',
    },
};
export const createGetReportTo = (location, slug) => {
    return {
        pathname: reverse(routing.analytics.overview.report.self, { reportType: slug }),
        search: location.search,
    };
};
export const AnalyticsReportsContainer = () => {
    const location = useLocation();
    const { analyticsParams } = useAnalyticsParams();
    const { mutateAsync } = useMutation({
        mutationFn: async (variables) => {
            const { data } = await AnalyticsApiClient.getReportCsv(...variables);
            return data;
        },
    });
    const getReportType = (report) => {
        if (report.slug) {
            return React.createElement(ButtonClean, { label: report.name, to: createGetReportTo(location, report.slug) });
        }
        return report.name;
    };
    const reportsData = useMemo(() => Object.entries(reports).map(([type, report]) => ({
        ...report,
        type,
    })), []);
    const handleOnDownload = async (type) => {
        const data = await mutateAsync([{ type, otype: 'CSV' }, analyticsParams]);
        downloadCsv(data, `${type}-${analyticsParams.from}-${analyticsParams.to}.csv`);
    };
    const table = {
        data: reportsData,
        headers: [
            {
                id: 'name',
                label: 'Report Type',
                render: getReportType,
            },
            {
                id: 'download',
                label: 'Download CSV',
                render: (item) => (React.createElement(DownloadButton, { type: "text", onDownload: () => handleOnDownload(item.type) })),
                alignment: 'right',
            },
        ],
    };
    const list = {
        data: reportsData,
        renderItem: (item) => (React.createElement(S.ListItem, null,
            React.createElement("div", null, getReportType(item)),
            React.createElement(DownloadButton, { type: "icon", onDownload: () => handleOnDownload(item.type) }))),
    };
    return React.createElement(AnalyticsReportsView, { table: table, list: list });
};
